"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProvinceEnum;
(function (ProvinceEnum) {
    ProvinceEnum["AB"] = "AB";
    ProvinceEnum["BC"] = "BC";
    ProvinceEnum["MB"] = "MB";
    ProvinceEnum["ON"] = "ON";
    ProvinceEnum["SK"] = "SK";
    ProvinceEnum["NU"] = "NU";
    ProvinceEnum["NT"] = "NT";
})(ProvinceEnum = exports.ProvinceEnum || (exports.ProvinceEnum = {}));
var Timezone;
(function (Timezone) {
    Timezone["PACIFIC"] = "America/Vancouver";
    Timezone["MOUNTAIN"] = "America/Edmonton";
    Timezone["CENTRAL"] = "America/Regina";
    Timezone["EASTERN"] = "America/Toronto";
    Timezone["ATLANTIC"] = "America/Halifax";
})(Timezone = exports.Timezone || (exports.Timezone = {}));
var RefundProductsType;
(function (RefundProductsType) {
    RefundProductsType["ACCESSORIES"] = "accessories";
    RefundProductsType["CANNABIS"] = "cannabis";
    RefundProductsType["MIXED"] = "mixed";
})(RefundProductsType = exports.RefundProductsType || (exports.RefundProductsType = {}));
var IndustryTypeIds;
(function (IndustryTypeIds) {
    IndustryTypeIds[IndustryTypeIds["CANNABIS"] = 1] = "CANNABIS";
    IndustryTypeIds[IndustryTypeIds["CBD_HEMP"] = 2] = "CBD_HEMP";
    IndustryTypeIds[IndustryTypeIds["LIQUOR"] = 3] = "LIQUOR";
    IndustryTypeIds[IndustryTypeIds["SMOKE"] = 4] = "SMOKE";
    IndustryTypeIds[IndustryTypeIds["VAPE"] = 5] = "VAPE";
})(IndustryTypeIds = exports.IndustryTypeIds || (exports.IndustryTypeIds = {}));
//# sourceMappingURL=Company.js.map